import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Translation from '../../../v2/lang/Translation';
import getShouldShowAppDownloadButtons from '../../../v2/selectors/getShouldShowAppDownloadButtons';
import isUsingArtemisStyles from '../../../v2/selectors/isUsingArtemisStyles';
import {getSiteDataV2, isNewGuestUpdatedPage} from '../../../v2/selectors/selectors';
import DownloadButtonsLazyLoader from '../DownloadButtons/DownloadButtonsLazyLoader';
import useStyles from './CompletePageHeader.styles';

export function CompletePageHeader(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <header className={classes.headerContainer} data-test="CompletePageHeader">
      <h1 className={classes.header} data-test="CompletePageHeader__header">
        <Translation optionalExtension={props.siteCode}>checkout.complete.intro.heading.text</Translation>
      </h1>
      <h2 className={classes.subHeader} data-test="CompletePageHeader__subHeader">
        <Translation optionalExtension={props.siteCode}>checkout.complete.intro.paragraph.text</Translation>
      </h2>
      {props.shouldShowAppDownloadButtons && (
        <DownloadButtonsLazyLoader data-test="CompletePageHeader__appDownloadButtons" />
      )}
    </header>
  );
}

const mapStateToProps = state => ({
  isNewGuestUpdatedPage: isNewGuestUpdatedPage(state),
  siteCode: getSiteDataV2(state)?.siteCode,
  isUsingArtemisStyles: isUsingArtemisStyles(state),
  shouldShowAppDownloadButtons: getShouldShowAppDownloadButtons(state),
});

CompletePageHeader.propTypes = {
  isNewGuestUpdatedPage: PropTypes.bool.isRequired,
  siteCode: PropTypes.string.isRequired,
  shouldShowAppDownloadButtons: PropTypes.bool.isRequired,
};

export default connect(
  mapStateToProps,
)(CompletePageHeader);
